import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询停车位列表
export function listParkingSpaces(params) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.queryParkingSpaces',
      method: 'get',
      params: { ...params, communityId }
    }).then(response => {
      const res = response.data

      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加停车位
export function saveParkingSpace(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.saveParkingSpace',
      method: 'post',
      data: { ...data, communityId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '添加停车位失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 编辑停车位
export function editParkingSpace(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.editParkingSpace',
      method: 'post',
      data: { ...data, communityId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '编辑停车位失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除停车位
export function deleteParkingSpace(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.deleteParkingSpace',
      method: 'post',
      data: { ...data, communityId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询停车场列表
export function listParkingAreas(params) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingArea.listParkingAreas',
      method: 'get',
      params: { ...params, communityId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量添加停车位
export function batchSaveParkingSpace(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.batchSaveParkingSpace',
      method: 'post',
      data: { ...data, communityId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '批量添加停车位失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 下载停车位导入模板
 * @param {Object} params 参数
 * @returns {Promise}
 */
export function downloadParkingSpaceTemplate(params) {
  return request({
    url: '/car/parkingSpace/downloadTemplate',
    method: 'get',
    params,
    responseType: 'blob' // 重要：下载文件需要指定响应类型
  })
}


export function importParkingSpaceExcel(data) {
  return new Promise((resolve, reject) => {
    data.append('communityId', getCommunityId())
    request({
      url: '/callComponent/upload/assetImport/importData',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}


export function generateParkingSpaceContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/parkingSpace.GenerateParkingContractCmd', // 对应后端Cmd的serviceCode
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId() // 自动补充社区ID，与其他接口保持一致
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        // 返回合同Base64和文件名，便于前端下载
        resolve(res)
      } else {
        reject(new Error(res.msg || '生成车位租赁合同失败'))
      }
    }).catch(error => {
      // 捕获网络/系统异常，统一抛出错误信息
      reject(new Error(error.message || '生成合同请求异常，请稍后重试'))
    })
  })
}

// 查询停车场列表
export function ListParkingContractInfo(params) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.QueryParkingContractInfoCmd',
      method: 'get',
      params: { ...params, communityId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询停车场列表
export function listParkingHistoryContract(params) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.queryParkingSpaceHistoryContract',
      method: 'get',
      params: { ...params, communityId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


// 编辑停车位
export function EditParkingContract(data) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parkingSpace.EditParkingContractCmd',
      method: 'post',
      data: { ...data, communityId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '编辑停车位失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function exportParkingSpaceData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}